// extracted by mini-css-extract-plugin
export default {"image":"conclusion_image__KGNg4","logo":"conclusion_logo__Tl1wG","header":"conclusion_header__jUjiG"};